import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Company} from '../models/company';

export const companyDeleteActionTypes = {
  DELETE: type('[Company] Delete'),
  DELETE_SUCCESS: type('[Company] Delete Success'),
  DELETE_FAIL: type('[Company] Delete Fail'),
};

export class DeleteCompanyAction implements Action {
  readonly type = companyDeleteActionTypes.DELETE;
  constructor(public payload?: string) {}
}

export class DeleteCompanySuccessAction implements Action {
  readonly type = companyDeleteActionTypes.DELETE_SUCCESS;
  constructor(public payload?: Company) {}
}

export class DeleteCompanyFailAction implements Action {
  readonly type = companyDeleteActionTypes.DELETE_FAIL;
  constructor(public payload?: number) {}
}



